import CryptoJS from "crypto-js";

const SECRET_KEY = import.meta.env.VITE_STORAGE_SECRET || "ngud-secret-key";

export const encryptedStorage = {
    getItem(name) {
        try {
            const encrypted = sessionStorage.getItem(name);
            if (!encrypted) return null;

            const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
            const decrypted = bytes.toString(CryptoJS.enc.Utf8);

            if (!decrypted) return null;

            return JSON.parse(decrypted);
        } catch (err) {
            console.error("Decrypt error", err);
            sessionStorage.removeItem(name);
            return null;
        }
    },

    setItem(name, value) {
        try {
            const encrypted = CryptoJS.AES.encrypt(
                JSON.stringify(value),
                SECRET_KEY
            ).toString();

            sessionStorage.setItem(name, encrypted);
        } catch (err) {
            console.error("Encrypt error", err);
        }
    },

    removeItem(name) {
        sessionStorage.removeItem(name);
    }
};
